import type { FuelSavingCalibration } from "../types/strategyCalibration";

interface FuelSavingModelInput {
  calibration?: FuelSavingCalibration;
  defaultMaxFuelSavePercent: number;
  defaultPenaltyPerPercent: number;
}

export interface FuelSavingModel {
  maxFuelSavePercent: number;
  lapTimePenaltyPerPercent: number;
  calibrationActive: boolean;
  observedSavePercent: number | null;
}

export function buildFuelSavingModel({
  calibration,
  defaultMaxFuelSavePercent,
  defaultPenaltyPerPercent,
}: FuelSavingModelInput): FuelSavingModel {
  if (!calibration) {
    return {
      maxFuelSavePercent: defaultMaxFuelSavePercent,
      lapTimePenaltyPerPercent: defaultPenaltyPerPercent,
      calibrationActive: false,
      observedSavePercent: null,
    };
  }

  const {
    baselineLapTime,
    baselineFuelPerLap,
    saveLapTime,
    saveFuelPerLap,
  } = calibration;

  if (
    baselineLapTime <= 0 ||
    baselineFuelPerLap <= 0 ||
    saveLapTime <= 0 ||
    saveFuelPerLap <= 0 ||
    saveFuelPerLap >= baselineFuelPerLap ||
    saveLapTime <= baselineLapTime
  ) {
    return {
      maxFuelSavePercent: defaultMaxFuelSavePercent,
      lapTimePenaltyPerPercent: defaultPenaltyPerPercent,
      calibrationActive: false,
      observedSavePercent: null,
    };
  }

  const observedSavePercent = ((baselineFuelPerLap - saveFuelPerLap) / baselineFuelPerLap) * 100;
  if (observedSavePercent <= 0) {
    return {
      maxFuelSavePercent: defaultMaxFuelSavePercent,
      lapTimePenaltyPerPercent: defaultPenaltyPerPercent,
      calibrationActive: false,
      observedSavePercent: null,
    };
  }

  return {
    maxFuelSavePercent: defaultMaxFuelSavePercent,
    lapTimePenaltyPerPercent: (saveLapTime - baselineLapTime) / observedSavePercent,
    calibrationActive: true,
    observedSavePercent,
  };
}